export default "__VITE_ASSET__CvnUr_aS__"